var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingEmoji2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.8069 38.8069 50 25 50C11.1944 50 0 38.8069 0 25C0 11.1944 11.1944 0 25 0C38.8069 0 50 11.1944 50 25Z",
    fill: "#F8CD5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9722 27.7779C17.8899 27.7779 19.4444 25.6015 19.4444 22.9168C19.4444 20.2321 17.8899 18.0557 15.9722 18.0557C14.0546 18.0557 12.5 20.2321 12.5 22.9168C12.5 25.6015 14.0546 27.7779 15.9722 27.7779Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0279 27.7779C35.9455 27.7779 37.5001 25.6015 37.5001 22.9168C37.5001 20.2321 35.9455 18.0557 34.0279 18.0557C32.1102 18.0557 30.5557 20.2321 30.5557 22.9168C30.5557 25.6015 32.1102 27.7779 34.0279 27.7779Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 38.8884C19.4445 31.944 34.7223 31.944 34.7223 34.7218C34.7223 36.1106 23.6112 33.3329 16.6667 38.8884Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingEmoji2);
export default __webpack_public_path__ + "static/media/rating_emoji_2.aeed527240d7b078efe0fed9681ef700.svg";
export { ForwardRef as ReactComponent };